// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

//   React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import properties from "constants/ApplicationConstants";

function ComplexStatisticsCard({color, title, count, percentage, icon}) {
  return (
    <Card
      sx={{
        boxShadow: "0px 8px 24px rgba(24, 54, 122, 0.3)",
        borderRadius: "16px"
      }}
    >
      {" "}
      <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" pt={1} px={2}>
        <MDBox
          sx={{
            background: "linear-gradient(to bottom, #53B0E0, #2D2EAA) !important",
            flexShrink: 0
          }}
          variant="gradient"
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
        >
          <Icon fontSize="medium" color="inherit">
            {icon}
          </Icon>
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.3} sx={{flex: 1, minWidth: 0, ml: 1}}>
          <MDTypography
            variant="button"
            fontWeight="bold"
            color="text"
            sx={{
              fontFamily: properties.fontFamily,
              whiteSpace: "nowrap",
              display: "block"
            }}
          >
            {title}
          </MDTypography>
          <MDTypography variant="h4" sx={{fontFamily: properties.fontFamily}}>
            {count}
          </MDTypography>
        </MDBox>
      </MDBox>
      <Divider />
      <MDBox pb={2} px={2}>
        <MDTypography
          component="p"
          variant="button"
          color="text"
          display="flex"
          sx={{fontFamily: properties.fontFamily}}
        >
          <MDTypography
            component="span"
            variant="button"
            fontWeight="bold"
            color={percentage.color}
            sx={{fontFamily: properties.fontFamily}}
          >
            {percentage.amount}
          </MDTypography>
          &nbsp;{percentage.label}
        </MDTypography>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: ""
  }
};

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "bntColor",
    "success",
    "warning",
    "error",
    "light",
    "dark"
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "bntColor",
      "success",
      "warning",
      "error",
      "dark",
      "white"
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string
  }),
  icon: PropTypes.node.isRequired
};

export default ComplexStatisticsCard;
